import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['typeCheckbox', 'categoryItem']

  declare readonly typeCheckboxTargets: HTMLInputElement[]
  declare readonly categoryItemTargets: HTMLElement[]

  connect (): void {
    this.cascade()
  }

  cascade (): void {
    this.hideUnmatched(this.categoryItemTargets, this.selectedValues(this.typeCheckboxTargets), 'riskTypeId')
  }

  syncSnapshotLocation ({ target }: Event): void {
    if ((target as HTMLElement).id !== 'risk_insights') return

    Turbo.session.view.lastRenderedLocation = new URL(window.location.href)
  }

  private hideUnmatched (items: HTMLElement[], selected: string[], datasetKey: string): void {
    items.forEach(item => {
      const ownerId = item.dataset[datasetKey] ?? ''

      if (selected.length === 0 || selected.includes(ownerId)) {
        item.classList.remove('hidden')
        return
      }

      const checkbox = item.querySelector<HTMLInputElement>('input[type="checkbox"]')
      if (checkbox?.checked === true) {
        checkbox.checked = false
      }
      item.classList.add('hidden')
    })
  }

  private selectedValues (checkboxes: HTMLInputElement[]): string[] {
    return checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value)
  }
}
